// extracted by mini-css-extract-plugin
export default {"input":"DraggableCheckGroupHeader_input__dLjGv"};